// État du catalogue global des produits canoniques adoptables.
//
// La liste est chargée à la demande, lorsque l'utilisateur bascule sur
// « Catalogue » : la garder hors de l'amorçage de l'écran Stock évite de
// payer ses milliers d'entrées à ceux qui ne s'en servent pas.
export function catalogueReducer(state = {
    produits: [],
    loading: false,
    loaded: false,
    error: "",
    adopting: "",
}, {
    type,
    payload
}) {

    switch (type) {
        case "FETCH_CATALOGUE_START":
            return {
                ...state,
                loading: true,
                error: "",
            };

        case "FETCH_CATALOGUE_FULFILLED":
            return {
                ...state,
                loading: false,
                loaded: true,
                error: "",
                produits: payload,
            };

        case "FETCH_CATALOGUE_ERROR":
            return {
                ...state,
                loading: false,
                loaded: true,
                error: payload,
            };

        case "ADOPT_CATALOGUE_START":
            return {
                ...state,
                adopting: payload,
                error: "",
            };

        // L'entrée adoptée est marquée ici même, sans relire le catalogue :
        // celui-ci compte des milliers de lignes et son seul champ mouvant est
        // celui-là.
        case "ADOPT_CATALOGUE_FULFILLED":
            return {
                ...state,
                adopting: "",
                produits: state.produits.map(produit => (
                    produit.id === payload
                        ? { ...produit, deja_adopte: true }
                        : produit
                )),
            };

        case "ADOPT_CATALOGUE_ERROR":
            return {
                ...state,
                adopting: "",
                error: payload,
            };

        default:
            return state;
    }

}
